import * as Types from 'apps/shared/scripts/__generated__/graphql.generated';

import { gql } from '@apollo/client';
export type InvoiceFragment = { readonly __typename: 'Invoice', readonly cardId: string, readonly cardRecipient: string, readonly createdAt: any, readonly currencyCode: string, readonly id: string, readonly invoiceNumber: number, readonly status: string, readonly transactionId: string, readonly transactionTimestamp: any, readonly updatedAt: any, readonly userId: string, readonly customer: { readonly __typename: 'TransactionCustomer', readonly email: string, readonly address: { readonly __typename: 'TransactionAddress', readonly countryCode: string, readonly postalCode?: string | null, readonly city?: string | null, readonly region?: string | null, readonly firstLine?: string | null, readonly secondLine?: string | null } }, readonly item: { readonly __typename: 'TransactionItem', readonly id: string, readonly name?: string | null, readonly price: string }, readonly payment: { readonly __typename: 'TransactionPayment', readonly method: string, readonly card?: { readonly __typename: 'TransactionCard', readonly type?: string | null, readonly last4?: string | null } | null }, readonly totals: { readonly __typename: 'TransactionTotals', readonly subtotal: string, readonly tax: string, readonly discount: string, readonly total: string, readonly grandTotal: string } };

export type SimpleInvoiceFragment = { readonly __typename: 'Invoice', readonly cardRecipient: string, readonly currencyCode: string, readonly id: string, readonly invoiceNumber: number, readonly status: string, readonly transactionTimestamp: any, readonly totals: { readonly __typename: 'TransactionTotals', readonly grandTotal: string } };

export const InvoiceFragmentDoc = gql`
    fragment InvoiceFragment on Invoice {
  cardId
  cardRecipient
  createdAt
  currencyCode
  customer {
    address {
      countryCode
      postalCode
      city
      region
      firstLine
      secondLine
    }
    email
  }
  id
  invoiceNumber
  item {
    id
    name
    price
  }
  payment {
    method
    card {
      type
      last4
    }
  }
  status
  totals {
    subtotal
    tax
    discount
    total
    grandTotal
  }
  transactionId
  transactionTimestamp
  updatedAt
  userId
}
    `;
export const SimpleInvoiceFragmentDoc = gql`
    fragment SimpleInvoiceFragment on Invoice {
  cardRecipient
  currencyCode
  id
  invoiceNumber
  status
  transactionTimestamp
  totals {
    grandTotal
  }
}
    `;